import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import {
	QueryClient,
	QueryClientProvider,
	defaultShouldDehydrateQuery,
} from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import Cookie from "../packages/Cookie";
export * from "@tanstack/react-query";

const [id_token] = Cookie("id_token");

const cacheTime = 1000 * 60 * 60 * 1; // 1 Hour

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: Infinity,
			cacheTime,
		},
	},
});

try {
	const persister = createSyncStoragePersister({
		storage: window.sessionStorage,
	});

	if (
		!window?.location?.search ||
		window?.location?.search.indexOf("disableCache=true") === -1
	) {
		persistQueryClient({
			queryClient,
			persister,
			maxAge: cacheTime,
			buster: id_token,
			dehydrateOptions: {
				shouldDehydrateQuery: (query) => {
					return (
						defaultShouldDehydrateQuery(query) &&
						query?.options?.meta?.disableCache !== true
					);
				},
			},
		});
	}
} catch (e) {}

export const QueryProvider = ({ children }) => (
	<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export default queryClient;
